import React from "react";
import styled from "styled-components";
import { withRouter, NavLink, RouteComponentProps } from "react-router-dom";
import {
  Classes,
  Icon,
  Button,
  ButtonGroup,
  Navbar,
  Popover,
  Menu,
  MenuDivider,
  MenuItem,
  FormGroup,
  Callout,
  Divider,
  Slider,
  Label
} from "@blueprintjs/core";
import { Flex, Box } from "reflexbox";
import { withFirebase } from "../Firebase";
import { withAuthentication } from "../Session";
import Logo from "../Logo";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: hsl(240, 2%, 21%);
  border-right: 1px solid hsl(240, 2%, 29%);
  flex: 0 0 18em;
  max-width: 18em;
  overflow: hidden;
`;

const Content = styled.div`
  padding: 1rem;
`;

const Auth = styled.div`
  padding: 1rem;
  background: hsl(240, 2%, 29%);
`;

const UserCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow-wrap: break-word;
  overflow: hidden;
`;

const UserEmail = styled.div``;

const UserButton = styled.div``;

const SignupPopup = styled.div`
  padding: 1rem;
`;

interface ButtonsProps extends RouteComponentProps {
  firebase: any;
}

const Buttons = withRouter(({ history, firebase }: ButtonsProps) => {
  const onSignInWithApple = () => {
    firebase.doSignInWithApple().then(() => {
      history.push("/");
    });
  };

  const onSignInWithGoogle = () => {
    firebase.doSignInWithGoogle().then(() => {
      history.push("/");
    });
  };

  const onSignInWithFacebook = () => {
    firebase.doSignInWithFacebook().then(() => {
      history.push("/");
    });
  };
  return (
    <ButtonGroup fill>
      <Popover
        position="top-right"
        content={
          <SignupPopup>
            <Button
              intent="primary"
              onClick={() => {
                history.push("/signup");
              }}
            >
              Create vette.website account
            </Button>
            <br />
            <br />
            <Button onClick={onSignInWithApple} style={{ width: "100%" }}>
              Sign up with Apple
            </Button>
            <br />
            <br />
            <Button onClick={onSignInWithGoogle} style={{ width: "100%" }}>
              Sign up with Google
            </Button>
            <br />
            <br />
            <Button onClick={onSignInWithFacebook} style={{ width: "100%" }}>
              Sign up with Facebook
            </Button>
          </SignupPopup>
        }
      >
        <Button icon="new-person" intent="primary">
          Sign up
        </Button>
      </Popover>
      <Button
        icon="log-in"
        onClick={() => {
          history.push("/login");
        }}
      >
        Login
      </Button>
    </ButtonGroup>
  );
});

function Sidebar({ authUser, firebase }) {
  return (
    <Container>
      <Navbar>
        <Navbar.Group align="center">
          <Logo />
        </Navbar.Group>
      </Navbar>
      {authUser === null && (
        <Auth>
          <Callout intent="warning">
            <strong>You are not signed in.</strong>
            <br />
            Only the demo panel will be editable. Some features are not
            available.
          </Callout>
          <br />
          <Buttons firebase={firebase} />
        </Auth>
      )}
      <Content>
      </Content>
    </Container>
  );
}

export default withAuthentication(withFirebase(Sidebar));
